import { render, staticRenderFns } from "./channel-authorization-dialog.vue?vue&type=template&id=6dad9424&"
import script from "./channel-authorization-dialog.vue?vue&type=script&lang=js&"
export * from "./channel-authorization-dialog.vue?vue&type=script&lang=js&"
import style0 from "./channel-authorization-dialog.vue?vue&type=style&index=0&id=6dad9424&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports